<template>
  <!-- <div class="sa-page-paziente"> -->

  <div class="sa-page-paziente">
    <b-row style="overflow: auto">
      <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-page-paziente-col-scheda">
        <div class="sa-page-paziente-patient-info"><rsa-paziente-info-component
            :jsonData="jsonData"></rsa-paziente-info-component></div>
        <!-- <div class="sa-page-paziente-patient-attivita">
          <b-card class="sa-card sa-card-border" header="Eventi" header-tag="header" footer-tag="footer" title="">

          </b-card>
        </div> -->
        <div class="sa-page-paziente-patient-attivita">
          <b-card class="sa-card sa-card-border" header="Prestazioni Impegnative" header-tag="header"
            footer-tag="footer" title="">
            <template #header>
              <div class="d-flex justify-content-between align-items-center w-100">
                <span>Attivita</span>
              </div>
            </template>
            <!-- <div v-for="(accettazione, key) in attivitaPaziente()" :key="key">
              <div class="d-flex justify-content-between align-items-center p-2 mb-2 sa-accettazione-header"
                @click="toggleAccettazione(key)" style="cursor: pointer;">
                <h5 class="font-weight-bold">
                  Accettazione Data: {{ formatDateTime(accettazione.accettazione.dataAccettazione) }}
                </h5>

                <div>
                  <b-button variant="primary"
                    class="waves-effect waves-light width-sm no-text d-flex align-items-center justify-content-center"
                    style="height: 32px; width: 32px; padding: 0;">
                    <i class="bi" :class="isAccettazioneAperta(key) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  </b-button>
                </div>
              </div>
              <b-collapse style="padding:8px" :visible="isAccettazioneAperta(key)">
                <div v-for="(ricetta, keyricetta) in accettazione.ricette" :key="keyricetta" style="width: 100%;">

                  <div class="sa-ft-card-header p-1" @click="toggleRicetta(keyricetta)" style="cursor: pointer;">
                    <div class="sa-ft-section-icon">🚀</div>
                    <h4> {{ keyricetta }}</h4>

                    <div style="display: table; margin-left: auto; text-align: right;">
                      <span class="sa-ft-circle-wrapper"> {{ ricetta.prestazioni.length }}</span>
                    </div>

                    <span class="sa-ft-arrow-icon sa-ft-circle-wrapper-orange"
                      :class="{ 'is-open': isRicettaAperta(keyricetta) }">▼</span>
                  </div>
                  <b-collapse :visible="isRicettaAperta(keyricetta)">
                    <div class="sa-ft-modern-cards-wrapper" style="height: 250px !important;">
                      <b-row class="align-items-stretch">
                        <b-col cols="5">
                          <b-table :ref="'tablePrest_' + keyricetta" :id="'tblPrest_' + keyricetta" responsive
                            stacked="xl" striped hover :items="ricetta.prestazioni"
                            @row-selected="items => onRowSelected(items, keyricetta)" :fields="fieldsPrest" selectable
                            select-mode="single" :current-page="1" :per-page="2000" sort-icon-left head-variant="light"
                            class="sa-b-table sa-ft-table">
                            <template #cell(checkbox)="{ rowSelected, selectRow, unselectRow }">
                              <b-form-checkbox :checked="rowSelected"
                                @change="rowSelected ? unselectRow() : selectRow()">
                              </b-form-checkbox>
                            </template>
                          </b-table>
                        </b-col>

                        <b-col cols="7">

                          <b-table sticky-header style="max-height: 220px !important;"
                            :key="'tableApp_' + keyricetta + '_' + (prestazioniSelezionate[keyricetta.trim()] || 'none')"
                            :ref="'tableApp_' + keyricetta" :id="'tblApp_' + keyricetta" responsive striped hover
                            :items="getAppuntamentiSelezionati(ricetta, keyricetta)" :fields="fieldsAppuntamenti"
                            :current-page="1" :per-page="2000" sort-icon-left head-variant="light"
                            class="sa-b-table sa-ft-table" show-empty
                            empty-text="Seleziona una prestazione a sinistra per visualizzare gli appuntamenti">

                            <template #cell(riferimento)="row">
                              <strong style="font-size: small; display: inline-block;">
                                <strong class="w-100 d-block">{{
                                  formattaData(row.item.dataRiferimento)
                                }}</strong>
                                <small>{{
                                  getGiornoSettimana(row.item.dataRiferimento).toUpperCase()
                                }}</small>
                                <br>
                                {{ getOrario(row.item.dataOraInizio) }} - {{
                                  getOrario(row.item.dataOraFine)
                                }}
                              </strong>
                            </template>
                            <template #cell(actions)="row">
                              <b-container style="gap:8px">
                                <b-button @click="onClickEseguiAttivita(row)"
                                  v-if="row.item.statoAppuntamento == 'PRENOTATO'"
                                  variant="btn btn-success waves-effect waves-light width-sm no-text">
                                  <font-awesome-icon icon="check" />
                                </b-button>
                              </b-container>
                            </template>
                          </b-table>

                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>

                  <hr />
                  <br />
                </div>
              </b-collapse>
            </div> -->

          </b-card>

        </div>
        <!-- <div class="sa-page-paziente-patient-terapia-attiva">
					<paziente-terapie-attive class="sa-page-paziente-terapia-attiva"></paziente-terapie-attive>
				</div> -->
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import female from "@/assets/images/female.jpg";
import male from "@/assets/images/male.jpg";
import UtilityMixin from "../../../../utility/UtilityMixin";
// import PazienteDiarioComponent from "./PazienteDiarioComponent.vue";
import RsaPazienteInfoComponent from "../../components/RsaPazienteInfoComponent.vue";

// import PazienteAttivita from "./PazienteAttivita.vue";
// import PazienteTerapieAttive from "./PazienteTerapieAttive.vue";
// import RsaPazientePlanningGiornaliero from "../../components/RsaPazientePlanningGiornaliero.vue";
export default {
  mixins: [UtilityMixin],
  props: {
    idPaziente: String,
    btnAllegati: { type: Boolean, default: false },
    messageDanger: { type: Boolean, default: false },
    utente: {
      required: true,
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  // components: { PazienteDiarioComponent, },
  // components: { PazienteDiarioComponent, PazienteInfoComponent, PazienteAttivita, PazienteTerapieAttive },
  components: { RsaPazienteInfoComponent, },
  data() {
    return {
      titolo: "",
      pathResource: "/accettazioni",
      pagelink: "/paziente",
      linkback: "/rsagestioneospiti",
      linkMeasurement: "/lastmeasure",
      prestazioniSelezionate: {},
      appuntamentiProssimi: [{ data: new Date().getTime(), prestazione: "prestazione", operatore: "operatore.cognome", stato: 'PRENOTATO', last: true },],
      jsonData: { accettazioneAnagrafica: { sesso: null }, accettazioneStruttura: { denominazione: null }, accettazionePresidio: {} },
      terapia: [],
      misure: [],
      wtLogin: null,
      misurePrioritarie: [],
      pazienteTerapie: [],
      diario: [],
      misureRange: [],
      ricetteAperte: {},
      accettazioniAperte: {},
      attivitaPazienteItems: [],
      fieldsPrest: [
        {
          label: "",
          key: "checkbox",
          thStyle: "width: 2rem",
        },
        {
          label: "Codice",
          key: "codice",
          thStyle: "width: 5rem",
        },
        {
          label: "Descrizione",
          key: "descrizione",
          thStyle: "width: 5rem",
        },
        {
          label: "Ciclo",
          key: "ciclo",
          thStyle: "width: 5rem",
        },
      ],
      fieldsAppuntamenti: [

        {
          label: "Ciclo",
          key: "ciclo",
        },
        {
          label: "Appuntamento",
          key: "riferimento",
        },
        {
          label: "Stato",
          key: "statoAppuntamento",
        },
        {
          label: "",
          key: "actions",
          thStyle: "width: 2rem",
        },
      ],
    };
  },
  computed: {



    patientAvatar: {
      get: function () {
        let me = this;
        if (me.jsonData.sesso === "M") {
          return male;
        } else {
          return female;
        }
      },
    },
    btnEditAnagrafica: {
      get: function () {
        let me = this;
        return UtilityMixin.methods.verificaPermessi(me.utente, "pazienti", 4);
      },
    },
  },
  watch: {
    utente() {
      //console.log(value);
    },
  },
  mounted() {
    let me = this;

    if (me.idPaziente) {
      me.loadData();

      //me.loadDiario();
      // me.loadTerapie();
    }
  },
  methods: {
    returnlabel() {
      let label = this.$i18n.t("patient.rangeConfig.lblDetectedOn");
      return label;
    },
    formatDate(value) {
      if (value) {
        return moment(new Date(value)).format("DD-MM-YYYY");
      } else {
        return "---";
      }
    },
    formattaData(dataString) {
      if (!dataString) return '--';
      const parti = dataString.split('-');
      return `${parti[2]}/${parti[1]}/${parti[0]} `;
    },
    attivitaPaziente() {
      let returnVlaue = {};
      if (this.attivitaPazienteItems.length > 0) {
        for (let attivita of this.attivitaPazienteItems) {
          let key = attivita.idAccettazione;
          if (!returnVlaue[key]) {
            returnVlaue[key] = {
              ricette: {},
              accettazione: {
                dataAccettazione: attivita.dataAccettazione
              }
            };
          }
          let keyRicetta = attivita.nre ? attivita.nre.trim() : 'SENZA_RICETTA';
          if (!returnVlaue[key].ricette[keyRicetta]) {
            returnVlaue[key].ricette[keyRicetta] = {
              isOpen: false,
              appuntamenti: {},
              prestazioni: []
            }
          }
          let codicePrestazione = attivita.codicePrestazione;
          if (!returnVlaue[key].ricette[keyRicetta].prestazioni.find(e => e.codice == codicePrestazione)) {
            let objPrestazione = {
              codice: codicePrestazione,
              descrizione: attivita.descrizionePrestazione,
              ciclo: attivita.quantitaErogabile
            }
            returnVlaue[key].ricette[keyRicetta].prestazioni.push(objPrestazione);
          }
          if (!returnVlaue[key].ricette[keyRicetta].appuntamenti[codicePrestazione]) {
            returnVlaue[key].ricette[keyRicetta].appuntamenti[codicePrestazione] = []
          }
          returnVlaue[key].ricette[keyRicetta].appuntamenti[codicePrestazione].push(attivita);
        }
      }
      return returnVlaue;
    },
    onRowSelected(items, keyRicetta) {
      const cleanKey = keyRicetta.trim();
      if (items && items.length > 0) {
        this.$set(this.prestazioniSelezionate, cleanKey, items[0].codice);
      } else {
        this.$set(this.prestazioniSelezionate, cleanKey, null);
      }
    },
    getAppuntamentiSelezionati(ricetta, keyRicetta) {
      const cleanKey = keyRicetta.trim();
      const codiceSelezionato = this.prestazioniSelezionate[cleanKey];
      if (codiceSelezionato && ricetta.appuntamenti && ricetta.appuntamenti[codiceSelezionato]) {
        return ricetta.appuntamenti[codiceSelezionato];
      }
      return [];
    },
    onClickEseguiAttivita(row) {
      console.log(row);

    },
    toggleRicetta(keyRicetta) {
      const cleanKey = keyRicetta.trim();
      this.$set(this.ricetteAperte, cleanKey, !this.ricetteAperte[cleanKey]);
    },
    isRicettaAperta(keyRicetta) {
      const cleanKey = keyRicetta.trim();
      return !!this.ricetteAperte[cleanKey];
    },
    isAccettazioneAperta(keyAccettazione) {
      return !!this.accettazioniAperte[keyAccettazione];
    },
    toggleAccettazione(keyAccettazione) {
      this.$set(this.accettazioniAperte, keyAccettazione, !this.accettazioniAperte[keyAccettazione]);
    },
    formatDateTime(value) {
      if (value) {
        return moment(new Date(value)).format("DD-MM-YYYY HH:mm");
      } else {
        return "---";
      }
    },
    traslater(key) {
      return this.$i18n.t(key);
    },
    loadData() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
      axios
        .get(link + me.idPaziente)
        .then((response) => {
          me.jsonData = response.data.data;
          this.loadAccedttazionePrestazioniAttivita();
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getGiornoSettimana(dataString) {
      if (!dataString) return '--';
      const giornoSettimana = moment(dataString).locale('it').format('dddd');
      return giornoSettimana;
    },
    getOrario(data) {
      return moment(data).format("HH:mm");
    },
    onDashboard() {
      let me = this;
      me.$router.replace(me.pagelink + "/dashboard?idPaziente=" + me.idPaziente).catch((err) => {
        err;
      });
    },
    loadDiario() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/pazienteeventi" + "/";
      axios
        .get(link, { params: { idPaziente: me.idPaziente } })
        .then((response) => {
          me.diario = response.data.data.list;
        })
        .catch((e) => {
          console.log(e);
          //this.errors.push(e);
        });
    },
    loadAccedttazionePrestazioniAttivita() {
      let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioniagendaappuntamento/attivitaprestazioni/" + this.jsonData.accettazioneAnagrafica.identificativo;
      axios
        .get(link, { params: { idAccettazione: this.jsonData.id } })
        .then((response) => {
          this.attivitaPazienteItems = response.data.data;

        })
        .catch((e) => {
          console.log(e);
          //this.errors.push(e);
        });
    },
    loadTerapie() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/pazienteterapie/attiva";
      axios
        .get(link, { params: { idPaziente: me.idPaziente } })
        .then((response) => {
          me.terapia = response.data.data;
        })
        .catch((e) => {
          console.log("Error: " + e.response.status + " " + link);
        });
    },
    onClickAggiungiImpegnativa() { },
    onPazienteTeleconsulto: function () {
      let me = this;
      me.$router.replace("/paziente/teleconsulti/" + me.idPaziente).catch((err) => {
        err;
      });
    },
    onEdit: function () {
      let me = this;
      me.$router.replace(me.pagelink + "/edit/" + me.id).catch((err) => {
        err;
      });
    },
    onAllegati() {
      let me = this;
      me.$router.replace("/paziente/allegati/" + me.idPaziente).catch((err) => {
        err;
      });
    },
    gestisciApertura(item) {
      console.log(item);

      if (item) {
        this.$set(item, 'isOpen', true);

      }

    },
    gestisciChiusura(item) {
      console.log(item);

      if (item) {
        this.$set(item, 'isOpen', false);

      }

    },
  },
};
</script>

<style scoped>
.sa-page-paziente-col-scheda {
  background-color: transparent;
  display: flex;
  max-height: 100%;
  flex-direction: column;
  padding-right: 0px;
  padding-left: 0px;
}

.sa-page-paziente-patient-info {
  background-color: transparent;
}

.sa-page-paziente-patient-attivita {
  background-color: transparent;
}

.sa-page-paziente-patient-terapia-attiva {
  background-color: transparent;
  flex: 1;
  overflow: auto;
}

.sa-page-paziente {
  /* background-color: var(--bg-sidebar); */
  height: 100%;
  padding-left: 8px;
  padding-right: 8px;
}

.sa-page-paziente .row {
  height: 100%;
}

/* .sa-page-paziente .row .sa-page-paziente-col-scheda {
    max-height: 100%;
} */
.sa-page-paziente-diario-clinico {
  height: 100%;
}

.sa-page-paziente-col-diario {
  margin-bottom: 0px;
  padding-bottom: 15px;
  padding-right: 0px;
}

@media (max-width: 450px) {
  .sa-page-paziente-terapia-attiva {
    max-height: 380px;
  }

  .sa-page-paziente-col-diario {
    max-height: 380px;
  }
}

@media screen and (min-width: 450px) and (max-width: 1024px) {
  .sa-page-paziente-terapia-attiva {
    max-height: 33px;
  }

  .sa-page-paziente-col-diario {
    height: calc(100% - 7px);
    /* background-color: green; */
  }
}

@media screen and (min-width: 1024px) {

  /* .sa-page-paziente-terapia-attiva {
        max-height: 33%;
    } */
  .sa-page-paziente-col-diario {
    height: calc(100% - 7px);
    /* background-color: blue; */
  }
}

.sa-ft-form-card {
  padding: 15px !important;
}


.animation-enter-active,
.animation-leave-active {
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.animation-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.animation-enter-to {
  opacity: 1;
  transform: translateY(0px);
}

.animation-leave-from {
  opacity: 1;
  transform: translateY(0px);
}

.sa-ft-arrow-icon {
  display: inline-block;
  transition: transform 0.3s ease;
  font-size: 0.8rem;
  /* Regola la dimensione a piacimento */
  color: #6c757d;
  /* Colore grigio neutro, personalizzabile */
}

/* Quando il pannello è aperto, ruota la freccia verso l'alto */
.sa-ft-arrow-icon.is-open {
  transform: rotate(180deg);
}

.animation-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.sa-ft-value-combine-wrapper {
  font-family: 'Segoe UI', Roboto, sans-serif;
  border-radius: 8px;
  max-width: 200px;
}

.sa-ft-value-combine {
  margin-top: 8px;
  padding-left: 5px;
}

.sa-ft-value-combine-row {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 4px;
}

.sa-ft-circle-wrapper {
  /* Dimensioni e Forma */
  width: 30px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;

  /* Centratura del numero */
  display: flex;
  align-items: center;
  justify-content: center;

  /* Estetica */
  background-color: #007bff21;
  color: rgba(0, 47, 255, 0.712);
  font-family: sans-serif;
  font-weight: bold;
  font-size: 1.2rem;

  /* Opzionale: bordino o ombra */
  border: 2px solid #0056b3;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.sa-ft-circle-wrapper-orange {
  /* Dimensioni e Forma */
  width: 30px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;

  /* Centratura del numero */
  display: flex;
  align-items: center;
  justify-content: center;

  /* Estetica */
  background-color: #ff660021;
  color: rgba(233, 71, 22, 0.801);
  font-family: sans-serif;
  font-weight: bold;
  font-size: 1.2rem;

  /* Opzionale: bordino o ombra */
  border: 2px solid #b34800;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.sa-ft-value-combine-label {
  font-size: 0.98rem;
  color: #6c757d;
  font-weight: 600;
  width: 40px;
}

.sa-ft-value-combine-value {
  font-size: 0.80rem;
  color: #212529;
  font-weight: 700;
}
</style>
